module.exports = __webpack_public_path__ + "img/notify_default.94e2ba04.svg";